import Vue from 'vue'
import Vuex from 'vuex'

/* Theme Core */
import verticalMenu from './vertical-menu'
import appConfig from './app-config'
import app from './app'
/* App Core */
import users from './Admin/Core/users'
import userTypes from './Admin/Core/user_types'
import abilities from './Admin/Core/abilities'
import cropperUploads from './Admin/Core/cropper_uploads'
import fileUpload from './Admin/Core/file_upload'
/* App Data */
import dashboard from './Admin/App/dashboard'
import teams from './Admin/App/teams'
import teamMembers from './Admin/App/team_members'
import projects from './Admin/App/projects'
import tasks from './Admin/App/tasks'
import subtasks from './Admin/App/subtasks'
import subtaskAssignees from './Admin/App/subtask_assignees'
import taskWatchers from './Admin/App/task_watchers'
import guides from './Admin/App/guides'
import guideSteps from './Admin/App/guide_steps'
/* App Defines */
import departments from './Admin/Defines/departments'
import projectStatuses from './Admin/Defines/project_statuses'
import taskStatuses from './Admin/Defines/task_statuses'
import subtaskStatuses from './Admin/Defines/subtask_statuses'
import taskPriorities from './Admin/Defines/task_priorities'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    app,
    appConfig,
    abilities,
    cropperUploads,
    dashboard,
    fileUpload,
    users,
    userTypes,
    verticalMenu,
    departments,
    teams,
    teamMembers,
    projects,
    tasks,
    subtasks,
    subtaskAssignees,
    taskWatchers,
    guides,
    guideSteps,
    projectStatuses,
    taskStatuses,
    subtaskStatuses,
    taskPriorities,

  },
  strict: process.env.DEV,
})
